export default {
  GET_ALL: `#graphql
  query getCustomers($search: String, $searchBy: String, $search1: String, $searchBy1: String, $limit: Int, $page: Int, $sort: String, $order: String, $init: Date, $final: Date) {
    getCustomers(search: $search, searchBy: $searchBy, search1: $search1, searchBy1: $searchBy1, limit: $limit, page: $page, sort: $sort, order: $order, init: $init, final: $final) {
      docs {
        phone
        name
        email
        dni
        addresses {
          _id
          alias
          address
          location
          department
          community
          isDefault
        }
        active
        orderStatusNotifications {
          email
          whatsapp
          sms
        }
        createdAt
        updatedAt
      }
      totalDocs
      limit
      hasPrevPage
      hasNextPage
      page
      totalPages
      prevPage
      nextPage
      pagingCounter
    }
  }`,

  UPDATE: `#graphql
  mutation UpdateCustomer($phone: String!, $customerUpdate: CustomerUpdateInput!) {
    updateCustomer(phone: $phone, customerUpdate: $customerUpdate) {
      phone
      orderStatusNotifications {
        email
        whatsapp
        sms
      }
    }
  }`
}



// WEBPACK FOOTER //
// ./src/graphql/customer.js